module.exports = __webpack_public_path__ + "static/media/About-us.159bdaf6.png";